// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__iczql","copyright":"Footer_copyright__NOCvx"};